<button
  (click)="this.clicked.emit()"
  class="size-full rounded-xl text-black shadow-lg drop-shadow-md transition-transform hover:scale-105"
  [ngClass]="{ 'grayscale-100': disabled() }"
  [style]="`
    background: ${this.gradient().stop2};
    background: radial-gradient(circle, ${this.gradient().stop1} 0%, ${this.gradient().stop2} 100%);
    box-shadow:
      -5px -5px 0px 0px rgba(0, 0, 0, 0.25) inset,
      0 3px 0 0 rgba(255, 255, 255, 0.25) inset;
  `"
>
  <div [ngClass]="{ 'opacity-50': disabled() }">
    <ng-content></ng-content>
  </div>
</button>
